// src/shared/modules/ledgers/list/hooks/useLedgerData.ts
import { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { OrderRecord } from "../../types";
import api from "../../../../../features/auth/axiosConfig";

const useLedgerData = (currentPage: number, rowsPerPage: number, searchTerm: string,showZeroOutstanding: boolean) => {
  const [ledgerRecords, setLedgerRecords] = useState<OrderRecord[]>([]);
  const [visibleRecords, setVisibleRecords] = useState<OrderRecord[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalOutstanding, setTotalOutstanding] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const searchTimeout = useRef<NodeJS.Timeout | null>(null);
  const navigate = useNavigate();
  const [ledgerRecordsAll, setLedgerRecordsAll] = useState([]);

  useEffect(() => {
    if (searchTimeout.current) clearTimeout(searchTimeout.current);

    searchTimeout.current = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 1000);

    return () => {
      if (searchTimeout.current) clearTimeout(searchTimeout.current);
    };
  }, [searchTerm]);

  useEffect(() => {
    api.get("/pos/ledger?pageNumber=1&pageSize=999999").then((res) => setLedgerRecordsAll(res.data.result));
  }, []);

useEffect(() => {
  fetchLedgerRecords(
    currentPage + 1,
    rowsPerPage,
    debouncedSearch,
    showZeroOutstanding
  );
}, [currentPage, rowsPerPage, debouncedSearch, showZeroOutstanding]);


  const fetchLedgerRecords = useCallback((pageNumber: number, pageSize: number, search: string, showZeroOutstanding: boolean) => {
    setLoading(true);
    api
      .get(`/pos/ledger`, {
        params: {
          pageNumber,
          pageSize,
          searchBy: search,
          includeSettled: !showZeroOutstanding,
        },
      })
      .then((response) => {
        const data: OrderRecord[] = Array.isArray(response.data.result) ? response.data.result : [];
        setLedgerRecords(data);
        setVisibleRecords(data);
        setTotalRecords(response.data.totalRecords || 0);
        setTotalOutstanding(response.data.total_outstanding_balance || 0);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching ledger:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleRowClick = (id: string) => {
    navigate(`/v1/ledger/${id}`, {
      state: { customers: ledgerRecords },
    });
  };

  const formatCurrency = (value: number | undefined): string => {
    if (value === undefined) return "0.00";
    const num = Number(value);
    const thirdDecimal = Math.floor(num * 1000) % 10;
    return thirdDecimal >= 5 ? (Math.ceil(num * 100) / 100).toFixed(2) : num.toFixed(2);
  };

  return {
    ledgerRecords,
    visibleRecords,
    totalRecords,
    totalOutstanding,
    loading,
    handleRowClick,
    formatCurrency,
    showZeroOutstanding: false,
  };
};

export default useLedgerData;
